import React, { useEffect, useState } from "react";
import style from "./style.module.css";
import { useNavigate } from "react-router-dom";

const RekapanGym1 = (props) => {
  const today = new Date().toISOString().split("T")[0];
  const [dataRekapan, setDataRekapan] = useState([]);
  const [totalIncome, setTotalIncome] = useState(0);
  const [totalOutcome, setTotalOutcome] = useState("");
  const [cashIncome, setCashIncome] = useState(0);
  const [nonCashIncome, setNonCashIncome] = useState(0);
  const [date, setDate] = useState(today);
  const url = props.url;
  const navigate =useNavigate("");

  // function ambil data
  const AmbilDataAwal = () => {
    fetch(url + "/?op=getDataAllHistoryPengeluaranInventoryGymKaryawan", {
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: "date=" + date 
    })
    .then((response) => response.json())
    .then((json)=>{
        if(json==null){
    setCashIncome(0);
      setNonCashIncome(0);
      setTotalIncome(0);
      setDataRekapan([]);
        }else{
            const totalIncome = json.reduce((acc, item) => acc + parseInt(item.total), 0);
      const cashIncome = json.filter((item)=>item.metode ==="Cash").reduce((acc, item) => acc + parseInt(item.total), 0);
      const nonCashIncome = json.filter((item)=>item.metode ==="Non Cash").reduce((acc, item) => acc + parseInt(item.total), 0);
      setCashIncome(cashIncome);
      setNonCashIncome(nonCashIncome);
      setTotalIncome(totalIncome);
      setDataRekapan(json);
        }
    })
  };
  /*
    const AmbilDataAwal = async () => {
    try {
      const response = await fetch(`${url}/?op=getDataAllHistoryPengeluaranInventoryGymKaryawan`);
      const data = await response.json();
      const totalIncome = data.reduce((acc, item) => acc + parseInt(item.total), 0);
      const cashIncome = data.filter((item)=>item.metode ==="Cash").reduce((acc, item) => acc + parseInt(item.total), 0);
      const nonCashIncome = data.filter((item)=>item.metode ==="Non Cash").reduce((acc, item) => acc + parseInt(item.total), 0);
      setCashIncome(cashIncome);
      setNonCashIncome(nonCashIncome);
      setTotalIncome(totalIncome);
      setDataRekapan(data);
    } catch (error) {
      console.error('Error fetching items:', error);
    }
  };*/

  //function ganti tanggal
  const GantiTanggal = (value) => {
    setDate(value);
 
  };
  // function format rupiah
  const formatRupiah = (value) =>
  new Intl.NumberFormat("id-ID", {
    style: "currency",
    currency: "IDR",
    minimumFractionDigits: 0,
  }).format(value);

  //use effect
  useEffect(() => {
    AmbilDataAwal();
  }, [date]);
  // use effect cek session
      useEffect(()=>{
          fetch(url + "/?op=cekSession", {
              credentials: "include", 
            })
            .then((response)=>response.json())
            .then((json)=>{
             
            if (json === "kosong") {
                  navigate("/", { replace: true });
                }else if(json ==="gym2"){
      navigate("/gym2", { replace: true });
                }else if(json ==="owner"){
      navigate("/owner", { replace: true });
                }
            })
          },[])
  return (
    <div className={style.containerAll}>
      <div className={style.containerTabel}>
        <div className={style.judulTabel}>
          Rekapan Inventory Gym
          <div>
            <input
              value={date}
              onChange={(e) => GantiTanggal(e.target.value)}
              type="date"
            />
          </div>
        </div>
        <div className={style.divTabel}>
          <table className={style.tabel}>
            <thead>
              <tr>
                <th>Nama Barang</th>
                <th>Jumlah</th>
                <th>Total Harga</th>
                <th>Metode</th>
                <th>Keterangan</th>
              </tr>
            </thead>
            <tbody>
              {dataRekapan.map((item, index) => (
                <tr key={index}>
                  <td>{item.nama_barang}</td>
                  <td>{item.out_barang}</td>
                  <td>{item.total}</td>
                  <td>{item.metode}</td>
                  <td>{item.keterangan}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className={style.keteranganTabel}>
          <div>Cash : {formatRupiah(cashIncome)}</div>
  <div>Non Cash : {formatRupiah(nonCashIncome)}</div>
  <div style={{fontWeight:"bold"}}>Total Income : {formatRupiah(totalIncome)}</div>
        </div>
      </div>
    </div>
  );
};

export default RekapanGym1;
